/* Keep matching comparison rows aligned without changing card widths or typography. */
(() => {
  if (window.quiaComparisonAlignmentLoaded) return;
  window.quiaComparisonAlignmentLoaded = true;
  const initialized = new WeakSet();
  function initialize(root = document) {
    root.querySelectorAll('[data-align-comparison-rows]').forEach(grid => {
      if (initialized.has(grid)) return;
      initialized.add(grid);
      const columns = [...grid.querySelectorAll(':scope > .comparison-table__column')].map(card => ({
        card,
        head: card.querySelector('.comparison-table__column-head'),
        title: card.querySelector('.comparison-table__column-title'),
        list: card.querySelector('.comparison-table__features'),
        rows: [...card.querySelectorAll('.comparison-table__feature')]
      })).filter(column => column.head && column.title && column.list);
      if (columns.length < 2) return;
      const originals = new Map();
      function remember(element, properties) {
        originals.set(element, properties.map(property => [property, element.style.getPropertyValue(property), element.style.getPropertyPriority(property)]));
      }
      columns.forEach(column => {
        remember(column.head, ['padding-top']);
        remember(column.list, ['padding-top']);
        remember(column.title, ['height', 'min-height', 'max-height']);
        const content = document.createElement('span');
        content.style.width = '100%';
        content.style.display = 'block';
        while (column.title.firstChild) content.appendChild(column.title.firstChild);
        column.title.appendChild(content);
        column.title.style.display = 'flex';
        column.title.style.alignItems = 'center';
        column.title.style.justifyContent = 'center';
        column.content = content;
        column.rows.forEach(row => remember(row, ['height', 'min-height', 'max-height']));
      });
      // Bottom-aligned cards must not move their headings when row content grows.
      grid.style.alignItems = 'stretch';
      let pending = false;
      function align() {
        pending = false;
        if (!grid.isConnected || !grid.getBoundingClientRect().width) return;
        originals.forEach((properties, element) => properties.forEach(([property, value, priority]) => {
          if (value) element.style.setProperty(property, value, priority);
          else element.style.removeProperty(property);
        }));
        columns.forEach(column => {
          column.title.style.height = 'auto';
          column.title.style.maxHeight = 'none';
          column.rows.forEach(row => { row.style.height = 'auto'; row.style.maxHeight = 'none'; });
        });
        const titleHeight = Math.ceil(Math.max(...columns.map(column => Math.max(column.title.getBoundingClientRect().height, column.content.getBoundingClientRect().height))));
        columns.forEach(column => { column.title.style.height = `${titleHeight}px`; column.title.style.minHeight = `${titleHeight}px`; });
        const titleTop = Math.max(...columns.map(column => column.title.getBoundingClientRect().top));
        columns.forEach(column => {
          const difference = titleTop - column.title.getBoundingClientRect().top;
          if (difference > 0.1) column.head.style.paddingTop = `${parseFloat(getComputedStyle(column.head).paddingTop) + difference}px`;
        });
        const listTop = Math.max(...columns.map(column => column.rows[0]?.getBoundingClientRect().top || column.list.getBoundingClientRect().top));
        columns.forEach(column => {
          const rowTop = column.rows[0]?.getBoundingClientRect().top || column.list.getBoundingClientRect().top;
          if (listTop - rowTop > 0.1) column.list.style.paddingTop = `${parseFloat(getComputedStyle(column.list).paddingTop) + listTop - rowTop}px`;
        });
        const count = Math.max(...columns.map(column => column.rows.length));
        for (let index = 0; index < count; index++) {
          const rows = columns.map(column => column.rows[index]).filter(Boolean);
          const height = Math.ceil(Math.max(...rows.map(row => row.getBoundingClientRect().height)));
          rows.forEach(row => { row.style.height = `${height}px`; row.style.minHeight = `${height}px`; row.style.maxHeight = `${height}px`; });
        }
      }
      function schedule() { if (!pending) { pending = true; requestAnimationFrame(align); } }
      let widths = '';
      new ResizeObserver(() => {
        const next = columns.map(column => column.card.getBoundingClientRect().width.toFixed(2)).join(',');
        if (next !== widths) { widths = next; schedule(); }
      }).observe(grid);
      window.addEventListener('resize', schedule, { passive: true });
      grid.querySelectorAll('img').forEach(image => image.addEventListener('load', schedule));
      if (document.fonts) document.fonts.ready.then(schedule);
      schedule();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
